import { useCallback } from 'react'
import { useControlStore, useSelectionStore } from '@editorStores'
import { useSelectedPlanElementId } from '@editorHooks'
import { useStructuralPlanningSelection } from '@structuralPlanningHooks'
import usePlanElementSelection from './usePlanElementSelection'

const usePlanImageCardEditMode = () => {
  const { selectPlanElement, clearPlanSelection } = usePlanElementSelection()
  const selectedId = useSelectedPlanElementId('image-card')
  const setElementListCollapsed = useControlStore(state => state.setElementListCollapsed)
  const selectPlanElementInStore = useSelectionStore(state => state.selectPlanElement)
  const {
    params: { mode },
    actions: { toggleMode },
    modes: { isPlanImageCardMode },
  } = useStructuralPlanningSelection()

  const enterPlanImageCardEdit = useCallback(
    (cardId: string) => {
      selectPlanElementInStore(
        { type: 'plan', planElementType: 'image-card', guid: cardId },
        { mode: 'plan-image-card' },
      )
      setElementListCollapsed(false)
    },
    [selectPlanElementInStore, setElementListCollapsed],
  )

  // Scene selection: just select the card (shows the in-scene HUD/popup) without
  // switching to plan-image-card mode, so the right drawer form does not open —
  // matching how selecting a comment in the scene behaves (drawer-list driven).
  const selectPlanImageCardInScene = useCallback(
    (cardId: string) => {
      selectPlanElement('image-card', cardId)
    },
    [selectPlanElement],
  )

  const exitPlanImageCardEdit = useCallback(() => {
    clearPlanSelection()
    if (mode === 'plan-image-card') toggleMode()
  }, [clearPlanSelection, mode, toggleMode])

  return {
    selectedId,
    isPlanImageCardMode,
    enterPlanImageCardEdit,
    selectPlanImageCardInScene,
    exitPlanImageCardEdit,
  }
}

export default usePlanImageCardEditMode
